module.exports = __webpack_public_path__ + "img/bkg-outline-mountains.e9ee36fd.svg";